"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./init.request"), exports);
(0, tslib_1.__exportStar)(require("./detail.request"), exports);
(0, tslib_1.__exportStar)(require("./readNews.request"), exports);
(0, tslib_1.__exportStar)(require("./deleteNews.request"), exports);
(0, tslib_1.__exportStar)(require("./centerList.request"), exports);
(0, tslib_1.__exportStar)(require("./centerDetail.request"), exports);
//# sourceMappingURL=index.js.map